import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { cfaList } from "../../redux/actions/cfaAction";
import "../products/productDetail.css";
import CFATableData from "./cfa-list-table-data";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import NumberPagination from "../../components/Pagination/number-pagination";
import { useNavigate } from "react-router-dom";

const CFATable = ({ search, page_no, status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [cfaListData, setCfaListData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    fetchCfaList();
  }, [page, status, search]);

  const fetchCfaList = () => {
    dispatch(
      cfaList(
        {
          page,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
          search,
        },
        onSuccess,
        onError
      )
    );
  };
  const onSuccess = (data) => {
    setLoading(false);
    setCfaListData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table" style={{ position: "relative" }}>
            <thead>
              <tr className="table-rows">
                <th className="table-heads" width={"5%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  CFA ID
                </th>
                <th className="table-heads " width={"10%"}>
                  CFA Name
                </th>
                <th className="table-heads " width={"10%"}>
                  CFA Depot Manager Name
                </th>
                <th className="table-heads " width={"10%"}>
                  CFA Depot Manager Mobile Number
                </th>
                <th className="table-heads " width={"15%"}>
                  CFA Email Address
                </th>
                <th className="table-heads" width={"6%"}>
                  Email Status
                </th>
                <th
                  ref={componentRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="status"
                            value={""}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/cfa?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="status"
                            value={"inactive"}
                            checked={status == "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/cfa?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/cfa?page=1${search ? `&search=${search}` : ""}`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads ps-4" width={"11%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : cfaListData?.cfa?.length > 0 ? (
                <>
                  {cfaListData?.cfa?.map((item, index) => (
                    <CFATableData
                      key={item.id}
                      data={item}
                      index={index}
                      fetchCfaList={fetchCfaList}
                      currentPage={cfaListData?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <>
                  <tr>
                    <td
                      colSpan="1"
                      className="text-center no-data-container fs_16"
                    >
                      <span>~ No Data Found ~</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading == true ? `loading-event` : ""}>
          {cfaListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={cfaListData?.pagination?.currentPage}
              totalPages={cfaListData?.pagination?.totalPages}
              path={"/cfa"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default CFATable;
